export default function alphaToHex(alpha: any) {
  return Math.round(255 * alpha)
    .toString(16)
    .toUpperCase();
}
